import { createEnum } from "@redotech/zod/zod-enum";

export enum ShipheroReturnStatus {
  COMPLETE = "complete",
  WAREHOUSE_COMPLETE = "warehouse complete",
  PENDING = "pending",
}

export const ShipheroReturnStatusZodSchema = createEnum(ShipheroReturnStatus, {
  enumName: "ShipheroReturnStatus",
});
